import Honeybadger from "@honeybadger-io/js"

// The old vendored build exposed the Honeybadger global.
window.Honeybadger = Honeybadger

// Called from each entrypoint on DOMContentLoaded (after the inline head
// script has set window.jekyllEnv), matching the old sprockets bundles.
export function configureHoneybadger() {
  Honeybadger.configure({
    apiKey: "5f34ecd2",
    environment: window.jekyllEnv || "development",
    maxErrors: 10,
  })

  Honeybadger.beforeNotify(function (notice) {
    if (/UnhandledPromiseRejectionWarning/.test(notice.message)) {
      return false
    }
    if (/ResizeObserver loop completed/.test(notice.message)) {
      return false
    }
  })
}

export default Honeybadger
